import * as ActionTypes from './layout.actionTypes';

export const breakpointChange = data => (dispatch, getState) => {
  return dispatch({
    type: ActionTypes.BREAKPOINT_CHANGE,
    payload: data,
  });
};



// WEBPACK FOOTER //
// ./src/modules/layout/layout.actions.js